import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import Chart from "react-apexcharts";
import { createGlobalStyle } from 'styled-components';
import { DOCUMENT_LIST } from '../../prefixed/documents';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from '../../constants';
import {stringToHex} from "../forms/validator";
import axios from 'axios';

const JComponent= ({modalObject}) => {
  const navigate=useNavigate();
  const [rows,setRows]=useState([]);
  const [summaryRows,setSummaryRows]=useState([]);
  const [role,setRole]=useState("");
  useEffect(()=>{
	  if(localStorage.getItem("_xoxre")==="9999"){
		  setRole("9999");
	  }
  },[])  
  useEffect(()=>{
	loadNearestProjectsInTree(50);
  },[]);
  const getAssetType=(_catId,assetsCategoryList)=>{
	for(let i=0;i<assetsCategoryList.length;i++){
	  if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
	}
	return(_catId);
  }
  const getImplAgencyById=(_id,implAgencyList)=>{
	for(let i=0;i<implAgencyList.length;i++){
	  if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
	}
	return(_id);
  }
  const loadAssetCategoryList=async()=>{
	var config = {
	  method: 'post',
	  url: API_CORE_SERVER+"/api/get_asset_category.php",
	  headers: { 
		//'Content-Type': 'application/x-www-form-urlencoded',
		'Content-Type': 'application/json', 
	  },
	  data:{name:'hellominni'}
	  };
	 let records=await axios(config)
	  .then((response)=>{
		if(response.status===200 && response.data){
		  return(response.data);
		}
		return(null);
	  }).catch((response)=>{
		return(null);
	  });
	  return(records);
	}
	
	const loadImplAgencyList=async()=>{
	var config = {
	  method: 'post',
	  url: API_CORE_SERVER+"/api/get_impl_agency.php",
	  headers: { 
		//'Content-Type': 'application/x-www-form-urlencoded',
		'Content-Type': 'application/json', 
	  },
	  data:{name:'hellominni'}
	  };
	  let records=await axios(config)
	  .then((response)=>{
		if(response.status===200 && response.data){
		  return(response.data);
		}
		return(null);
	  }).catch((response)=>{
		return(null);
	  });
	  return(records);
	}
  const fecthNearestProjects=async(_distance)=>{
	let _rows=[];
	  let _d={
		  token:localStorage.getItem("_xoxex"),
		  email:"jilani.it@gmail.com",
			  distance:_distance
	  };
	  console.log(_d);
	  let idata=stringToHex(JSON.stringify(_d));
	  var config = {
		  method: 'post',
		  url: API_CORE_SERVER+"/api/map/extract-nearest-assets.php",
		  headers: { 
			  'Content-Type': 'application/x-www-form-urlencoded',
			  //'Content-Type': 'application/json', 
		  },
		  data:"i="+idata
		};
	  let _returnRecs=await axios(config)
		  .then((response)=>{
			  if(response.status===200 && response.data){
				  let data=response.data;
				  if(data.status===1 && data.data && data.data.length>0){
					  return(data.data);
				  }
				  
			  }
			  return(null);
		  }).catch((er)=>{
			  console.log(er);
		return(null);
		  })
	  return(_returnRecs)
   }

   const loadNearestProjectsInTree=async(_distance)=>{
	document.getElementById("nearestProjects").innerHTML="wait...";
    let loadAssetCategoryRecords=await loadAssetCategoryList();
    let loadImplAgencyRecords=await loadImplAgencyList();
    let data=await fecthNearestProjects(_distance);
    let html="\n \
   	    <table class='table mt-4 fs85rem' style='max-width:100%'>\n \
    	<thead>\n \
        	<tr>\n \
            	<th>Group<br/>Sln</th>\n \
                <th>Distance<br/>Meters</th>\n \
                <th>Implementing Agency</th>\n \
                <th>Funding Agency</th>\n \
                <th>Asset Type</th>\n \
                <th>Asset Name</th>\n \
                <th>Panchayat</th>\n \
                <th>Block</th>\n \
           </tr>\n \
        </tr>\n \
    	</thead>";
        let ihtml="";   
        let bg=["#efefef","#efeee6","#ececd0"];
        for(let i=0;i<data.length;i++){
            let rec=data[i];  
         for(let j=0;j<rec.length;j++){
          let irec=rec[j];
          ihtml=ihtml+"<tr style='background-color:"+bg[i%3]+"'>";
          if(j==0)
              ihtml=ihtml+"<td><b>"+(i+1)+"</b></td>";
          else
             ihtml=ihtml+"<td></td>";
          ihtml=ihtml+"<td><a target='_blank' href='https://ramgarhgramsampati.in/public/document-details.php?vi="+irec.assetId+"' class='px-4 border rounded-4 bg-primary text-white'>"+(irec.distance===undefined?"0":irec.distance)+"m</a></td>";  
          ihtml=ihtml+"<td>"+getImplAgencyById(irec.implementAgency,loadImplAgencyRecords)+"</td>";
          ihtml=ihtml+"<td>"+irec.fundingAgency+"</td>";
          ihtml=ihtml+"<td>"+getAssetType(irec.assetType,loadAssetCategoryRecords)+"</td>";
          ihtml=ihtml+"<td>"+irec.assetName+"</td>";
          ihtml=ihtml+"<td>"+irec.panchayat+"</td>";
          ihtml=ihtml+"<td>"+irec.block+"</td>";
          ihtml=ihtml+"</tr>";
         }
        
        }
        html=html+ihtml+"</table>";
        document.getElementById("nearestProjects").innerHTML=html;
    
}  
  

return(
	<>
	<div className='row'>
		<div className='col-md-12 p-4'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-arrows-move'></i> Nearest Projects Geo distance wise</h5>
			<div className='card'>
				<div className='card-body'>
					<div class='col-md-12 text-end'>
						<div class="btn-group">
							<button  type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
								Assets under <span id='geo_distance_btn'>50m</span>
							</button>
							<ul class="dropdown-menu">
								<li><a class="dropdown-item" href="#" onClick={e=>loadNearestProjectsInTree(10)}>Assets under 10m</a></li>
								<li><a class="dropdown-item" href="#" onClick={e=>loadNearestProjectsInTree(50)}>Assets under 50m</a></li>
								<li><a class="dropdown-item" href="#" onClick={e=>loadNearestProjectsInTree(100)}>Assets under 100m</a></li>
								<li><a class="dropdown-item" href="#" onClick={e=>loadNearestProjectsInTree(200)}>Assets under 200m</a></li>
								<li><a class="dropdown-item" href="#" onClick={e=>loadNearestProjectsInTree(500)}>Assets under 500m</a></li>
							</ul>
							</div>
					</div>
					<div class='col-md-12' style={{overflowX:"scroll"}} id="nearestProjects">

					</div>
				</div>
			</div>
			
		</div>
		
	</div>
	</>

);
};
export default JComponent;